import React from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import { Link } from 'gatsby';
import blogIcon from '../../images/blog-icon.svg';

const ResourceCard = ({ blogItem, index, url, external }) => {
    return (
        <>
            {external === 'no' &&
                <Link target="_blank" rel="noreferrer" to={`/${url}/${blogItem.node.slug}/`} className={`cp-blogWrapper__section l--borderRadiusLarge l--gridBorder l-slug-${blogItem.node.slug}`} key={index}>
                    <span className="cp-blogWrapper__image">
                        {blogItem.node.featuredImage ?
                            <>
                                {
                                    blogItem.node.featuredImage ?
                                        <GatsbyImage className="l--borderRadiusLarge" image={getImage(blogItem.node.featuredImage.node.gatsbyImage)} alt={blogItem.node.featuredImage.node.altText} />
                                        :
                                        <img src={blogItem.node.featuredImage.node.sourceUrl} alt={blogItem.node.featuredImage.node.altText} />
                                }
                            </>
                            :
                            <>
                                <StaticImage src="../../images/blog-placeholder-1.jpg" alt="" />
                            </>
                        }

                    </span>
                    <span className="cp-blogWrapper__content l--padding">
                        <h3 className="l--flex l-nobullet">
                            {process.env.GATSBY_LANG === 'de' ?
                                <>
                                    {blogItem.node.whitePapersAndEbooks ?
                                        <span className="cp-blogWrapper__type">
                                            {blogItem.node.whitePapersAndEbooks.resourceType === "analystreport" ? "Analystenbericht" :
                                                blogItem.node.whitePapersAndEbooks.resourceType === "podcast" ? "Podcasts" :
                                                    blogItem.node.whitePapersAndEbooks.resourceType === "infographics" ? "Guides" :
                                                        blogItem.node.whitePapersAndEbooks.resourceType === "finance-how-to" ? "Finance How To" :
                                                            blogItem.node.whitePapersAndEbooks.resourceType === "whitepaper" ? "Whitepaper" :
                                                                blogItem.node.whitePapersAndEbooks.resourceType === "marketing" ? blogItem.node.whitePapersAndEbooks.resourceTypeName :
                                                                    blogItem.node.whitePapersAndEbooks.resourceType
                                            }
                                        </span>
                                        :
                                        blogItem.node.eventsPostFields ?
                                            <span className="cp-blogWrapper__type">{blogItem.node.eventsPostFields.eventType === "virtual" ? "On-demand" : "Events"}</span>
                                            :
                                            <span className="cp-blogWrapper__type">{blogItem.node.nodeType}</span>
                                    }
                                </>
                                :
                                <>
                                    {blogItem.node.whitePapersAndEbooks ?
                                        <span className="cp-blogWrapper__type">
                                            {blogItem.node.whitePapersAndEbooks.resourceType === "analystreport" ? "Analyst Report" :
                                                blogItem.node.whitePapersAndEbooks.resourceType === "podcast" ? "Podcast" :
                                                    blogItem.node.whitePapersAndEbooks.resourceType === "infographics" ? "Guides" :
                                                        blogItem.node.whitePapersAndEbooks.resourceType === "finance-how-to" ? "Finance How To" :
                                                            blogItem.node.whitePapersAndEbooks.resourceType === "whitepaper" ? "White Paper" :
                                                                blogItem.node.whitePapersAndEbooks.resourceType === "marketing" ? blogItem.node.whitePapersAndEbooks.resourceTypeName :
                                                                    blogItem.node.whitePapersAndEbooks.resourceType
                                            }
                                        </span>
                                        :
                                        blogItem.node.eventsPostFields ?
                                            <span className="cp-blogWrapper__type">{blogItem.node.eventsPostFields.eventType === "virtual" ? "On Demand Webinar" : "Upcoming Event"}</span>
                                            :
                                            <span className="cp-blogWrapper__type">{blogItem.node.nodeType}</span>
                                    }
                                </>
                            }

                        </h3>
                        {blogItem.node.title &&
                            <h4 className="l--flex"><span className="cp-blogWrapper__content-title" dangerouslySetInnerHTML={{ __html: blogItem.node.title }}></span><span className="cp-blogWrapper__content-titleIcon"><img src={blogIcon} alt="" /></span></h4>
                        }
                        {blogItem.node.excerpt &&
                            <div dangerouslySetInnerHTML={{ __html: blogItem.node.excerpt.length > 100 ? blogItem.node.excerpt.substring(0, 100) + "..." : blogItem.node.excerpt }} />
                        }
                    </span>
                </Link>
            }
            {/* For external links sections like In-news */}
            {external === 'yes' &&
                <a href={url} target="_blank" rel="noreferrer" className="cp-blogWrapper__section l--borderRadiusLarge l--gridBorder" key={index}>
                    <span className="cp-blogWrapper__image">
                        {blogItem.node.featuredImage ?
                            <>
                                {
                                    blogItem.node.featuredImage ?
                                        <GatsbyImage className="l--borderRadiusLarge" image={getImage(blogItem.node.featuredImage.node.gatsbyImage)} alt={blogItem.node.featuredImage.node.altText} />
                                        :
                                        <img src={blogItem.node.featuredImage.node.sourceUrl} alt={blogItem.node.featuredImage.node.altText} />
                                }
                            </>
                            :
                            <>
                                <StaticImage src="../../images/blog-placeholder-1.jpg" alt="" />
                            </>
                        }

                    </span>
                    <span className="cp-blogWrapper__content l--padding">
                        <h3 className="l--flex l-nobullet">
                            {blogItem.node.whitePapersAndEbooks ?
                                <span className="cp-blogWrapper__type">
                                    {blogItem.node.whitePapersAndEbooks.resourceType === "analystreport" ? "Analyst Report" :
                                        blogItem.node.whitePapersAndEbooks.resourceType === "podcast" ? "Podcast" :
                                            blogItem.node.whitePapersAndEbooks.resourceType === "infographics" ? "Guides" :
                                                blogItem.node.whitePapersAndEbooks.resourceType === "finance-how-to" ? "Finance How To" :
                                                    blogItem.node.whitePapersAndEbooks.resourceType === "whitepaper" ? "White Paper" :
                                                        blogItem.node.whitePapersAndEbooks.resourceType
                                    }
                                </span>
                                :
                                <span className="cp-blogWrapper__type">{blogItem.node.nodeType}</span>
                            }
                        </h3>
                        {blogItem.node.title &&
                            <h5 className="l--flex"><span className="cp-blogWrapper__content-title" dangerouslySetInnerHTML={{ __html: blogItem.node.title }}></span><span className="cp-blogWrapper__content-titleIcon"><img src={blogIcon} alt="" /></span></h5>
                        }
                        {blogItem.node.excerpt &&
                            <span dangerouslySetInnerHTML={{ __html: blogItem.node.excerpt.length > 100 ? blogItem.node.excerpt.substring(0, 100) + "..." : blogItem.node.excerpt }} />
                        }
                        {blogItem.node.categories &&
                            <div className="cp-categories l--flex l--flexWrap">
                                {blogItem.node.categories.nodes.map((categoryList, index) => (
                                    <span className="l--borderRadiusLarge" key={index}>{categoryList.name}</span>
                                ))}
                            </div>
                        }
                    </span>
                </a>
            }
        </>
    );
}

export default ResourceCard;